import { UploadImage } from "components";
import { MediaDirectoryKeys } from "constants/enums";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import {
  AdditionalAttributesBlock,
  GeneralAttributes,
  ProductDetailsBlock
} from "./atoms";
import { useSubChildCategoryForm } from "./hooks";
import { SubChildCategoryFormProps } from "./SubChildCategoryForm.types";

import styles from "./SubChildCategoryForm.module.scss";

const SubChildCategoryForm = ({
  formId,
  category,
  onSubmit
}: SubChildCategoryFormProps) => {
  const { t } = useTranslation();
  const {
    control,
    attributes,
    isMaxMainFilters,
    onAppendAttribute,
    onRemoveAttribute,
    handleSubmit
  } = useSubChildCategoryForm(category);

  return (
    <form
      className={styles["sub-child-category-form"]}
      id={formId}
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className={styles["sub-child-category-form__header"]}>
        <Controller
          control={control}
          name="image"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <UploadImage
              className={styles["sub-child-category-form__header--uploader"]}
              value={value}
              onChange={onChange}
              errorMessage={error?.message}
              uploadDirectoryKey={MediaDirectoryKeys.Category}
              data-testid="sub-child-category--image"
            />
          )}
        />
        <Controller
          control={control}
          name="name"
          render={({ field, fieldState: { error } }) => (
            <Input
              label={t("Sub-sub-category name")}
              placeholder={t("Enter sub-sub-category name")}
              {...field}
              maxLength={50}
              errorMessage={error?.message}
              data-testid="sub-child-category--name"
            />
          )}
        />
      </div>

      <GeneralAttributes
        control={control}
        attributes={attributes}
        isMaxMainFilters={isMaxMainFilters}
      />

      <ProductDetailsBlock
        control={control}
        attributes={attributes}
        onAppendAttribute={onAppendAttribute}
        onRemoveAttribute={onRemoveAttribute}
      />

      <AdditionalAttributesBlock
        control={control}
        attributes={attributes}
        isMaxMainFilters={isMaxMainFilters}
        onAppendAttribute={onAppendAttribute}
        onRemoveAttribute={onRemoveAttribute}
      />
    </form>
  );
};

export default SubChildCategoryForm;
